import { render, staticRenderFns } from "./VisitMaterialRowsTable.vue?vue&type=template&id=57d52b5e&scoped=true"
import script from "./VisitMaterialRowsTable.vue?vue&type=script&lang=js"
export * from "./VisitMaterialRowsTable.vue?vue&type=script&lang=js"
import style0 from "./VisitMaterialRowsTable.vue?vue&type=style&index=0&id=57d52b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d52b5e",
  null
  
)

export default component.exports